import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lib-list-page',
  templateUrl: './list-page.component.html',
  styleUrls: ['./list-page.component.scss']
})
export class ListPageComponent implements OnInit {

  @Input()
  lists =[];

  constructor() { }

  ngOnInit() {
  }

}
